import { DEFAULT_PAGE_SIZE } from 'components/common/DataGridDevEx/DataGrid.constants';
import { fetchGet, objectify } from '../utils'

export const search = (query) => {
  const { PurchaseOrder, Page, Sort, SortDirection, BatchSize = DEFAULT_PAGE_SIZE } = query

  return fetchGet(`/PurchaseOrderEnquiry/PurchaseOrder/${PurchaseOrder}/CommittedServiceOrders`,
    { BatchSize, BatchPage: Page, Sort: (Sort && SortDirection && `${Sort}:${SortDirection}`) || '' }, 'Inline')
    .then((result) => {
      if (result) {
        if (result.CommittedServiceOrders) {
          return {
            records: result.CommittedServiceOrders.map((val) =>
              Object.assign({}, objectify(val))),
            nextPage: result.BatchInformation && !result.BatchInformation.EndOfData,
            currPage: result.BatchInformation && result.BatchInformation.BatchPage,
          }
        }
        else {
          return result
        }
      }
    })
}